// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__X90N0","label":"Labeled_label__2N7oa","divider":"Labeled_divider__5B_jA"};